/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../root'
import SettingsForm from './Form'

const PageSettingsMySettings: React.FC = () => {
  const { service } = useServiceContext()
  const translate = service.filter.translate

  return (
    <div className="mcc-content-frame theme-sandman">
      <div className="page-frame">
        <div className="d-flex flex-wrap">
          <h1 className="align-left align-top" id="6621be14-4845-4efa-bf9b-8c3061563867" style={{ margin: '0' }}>
            {translate('MY_EDGE_RCM_SETTINGS')}
          </h1>
          <div className="align-right align-bottom d-flex"></div>
        </div>
        <div className="page-content">
          <SettingsForm />
        </div>
      </div>
    </div>
  )
}

export default PageSettingsMySettings
